if (!customElements.get('usp-slider')) {
  customElements.define(
    'usp-slider',
    class UspSlider extends HTMLElement {
      connectedCallback() {
        // PDP USP slider
        if (this.querySelector('.usp-slider__swiper')) {
          this.initPdpSlider();
          return;
        }

        // Cart USP slider
        this.initCartSlider();
      }

      /* =========================================
         PDP USP SLIDER
      ========================================= */

      initPdpSlider() {
        const swiperEl = this.querySelector('.usp-slider__swiper');

        if (!swiperEl) return;

        // Prevent duplicate initialization
        if (swiperEl.swiper) return;

        const slides = swiperEl.querySelectorAll('.usp-slide');

        // No slider needed with one slide
        if (slides.length <= 1) {
          this.querySelector('.usp-slider__arrow--prev')?.setAttribute('hidden', '');
          this.querySelector('.usp-slider__arrow--next')?.setAttribute('hidden', '');
          return;
        }

        // Make sure Swiper is available
        if (typeof Swiper === 'undefined') {
          console.warn('Swiper is not loaded.');
          return;
        }

        const prevButton = this.querySelector('.usp-slider__arrow--prev');
        const nextButton = this.querySelector('.usp-slider__arrow--next');

        const autoplayEnabled = this.dataset.autoplay === 'true';
        const autoplaySpeed =
          parseInt(this.dataset.autoplaySpeed, 10) || 5000;

        const swiperOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,

          navigation: {
            prevEl: prevButton,
            nextEl: nextButton,
          },
        };

        if (autoplayEnabled) {
          swiperOptions.autoplay = {
            delay: autoplaySpeed,
            disableOnInteraction: false,
          };
        }

        new Swiper(swiperEl, swiperOptions);
      }

      /* =========================================
         CART USP SLIDER
      ========================================= */

      initCartSlider() {
        this.messages = (this.dataset.messages || '')
          .split('||')
          .filter(Boolean);

        this.index = 0;

        this.textEl = this.querySelector('.order-summary__usp-text');
        this.contentEl = this.querySelector('.order-summary__usp-content');
        this.prevEl = this.querySelector('.order-summary__usp-arrow--prev');
        this.nextEl = this.querySelector('.order-summary__usp-arrow--next');

        this.dotEls = Array.from(
          this.querySelectorAll('.order-summary__usp-dot')
        );

        if (this.messages.length <= 1) {
          if (this.prevEl) this.prevEl.hidden = true;
          if (this.nextEl) this.nextEl.hidden = true;

          this.dotEls.forEach((dot) => {
            dot.hidden = true;
          });

          return;
        }

        this.prevEl?.addEventListener('click', () => {
          this.show(this.index - 1);
        });

        this.nextEl?.addEventListener('click', () => {
          this.show(this.index + 1);
        });

        this.dotEls.forEach((dot, dotIndex) => {
          dot.addEventListener('click', () => {
            this.show(dotIndex);
          });
        });

        this.setupDrag();
      }

      /* =========================================
         CART DRAG / SWIPE
      ========================================= */

      setupDrag() {
        if (!this.contentEl) return;

        const DRAG_THRESHOLD = 40;

        let dragging = false;
        let startX = 0;
        let deltaX = 0;

        this.contentEl.style.touchAction = 'pan-y';
        this.contentEl.style.cursor = 'grab';

        const onPointerDown = (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) {
            return;
          }

          dragging = true;
          startX = event.clientX;
          deltaX = 0;

          this.contentEl.setPointerCapture(event.pointerId);
          this.contentEl.classList.add('is-dragging');
          this.contentEl.style.cursor = 'grabbing';
        };

        const onPointerMove = (event) => {
          if (!dragging) return;

          deltaX = event.clientX - startX;
        };

        const endDrag = (event) => {
          if (!dragging) return;

          dragging = false;

          this.contentEl.classList.remove('is-dragging');
          this.contentEl.style.cursor = 'grab';

          if (this.contentEl.hasPointerCapture(event.pointerId)) {
            this.contentEl.releasePointerCapture(event.pointerId);
          }

          if (Math.abs(deltaX) >= DRAG_THRESHOLD) {
            this.show(
              this.index + (deltaX < 0 ? 1 : -1)
            );
          }

          deltaX = 0;
        };

        this.contentEl.addEventListener(
          'pointerdown',
          onPointerDown
        );

        this.contentEl.addEventListener(
          'pointermove',
          onPointerMove
        );

        this.contentEl.addEventListener(
          'pointerup',
          endDrag
        );

        this.contentEl.addEventListener(
          'pointercancel',
          endDrag
        );
      }

      /* =========================================
         CART SHOW SLIDE
      ========================================= */

      show(index) {
        const total = this.messages.length;

        this.index = (index + total) % total;

        if (this.textEl) {
          this.textEl.textContent =
            this.messages[this.index];
        }

        this.dotEls.forEach((dot, dotIndex) => {
          dot.classList.toggle(
            'is-active',
            dotIndex === this.index
          );
        });
      }
    }
  );
}